import type { CalendarDate } from "../shared/calendar-date";
import { requireFinitePositive, roundTo } from "../shared/validation";
import {
  FIVE_CALENDAR_DAY_TREND_POLICY_VERSION,
  type WeightTrendSample,
} from "./rolling-average";

export const ONBOARDING_WEIGHT_REFERENCE_ID = "onboarding" as const;

/**
 * Immutable snapshot of the user's onboarding measurement. It is the previous
 * trend reference for the first check-in and is intentionally independent of an
 * editable daily weight record.
 */
export interface OnboardingWeightReference {
  readonly id: typeof ONBOARDING_WEIGHT_REFERENCE_ID;
  readonly date: CalendarDate;
  readonly weightKilograms: number;
  readonly samples: readonly [WeightTrendSample];
  readonly trendPolicyVersion: typeof FIVE_CALENDAR_DAY_TREND_POLICY_VERSION;
  readonly createdAt: string;
}

export function createOnboardingWeightReference(input: {
  readonly date: CalendarDate;
  readonly weightKilograms: number;
  readonly createdAt: string;
}): OnboardingWeightReference {
  requireFinitePositive(input.weightKilograms, "Onboarding reference weight");
  if (!input.createdAt.trim()) throw new Error("Onboarding reference creation time is required");
  const weightKilograms = roundTo(input.weightKilograms, 3);
  return {
    id: ONBOARDING_WEIGHT_REFERENCE_ID,
    date: input.date,
    weightKilograms,
    samples: [{ date: input.date, kilograms: weightKilograms }],
    trendPolicyVersion: FIVE_CALENDAR_DAY_TREND_POLICY_VERSION,
    createdAt: input.createdAt,
  };
}
